import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, EDIT } from "const"
import {
    okrSessionBaseRoute,
    okrObjectivesAllRoute,
    okrObjectivesNestedRoute,
    okrObjectivesTreeRoute,
    okrKeyResultsRoute,
} from "client/parts/routes"
import {
    StoreType,
    setOkrObjectiveRoute,
} from "client/store"
import { Switch, Route } from "client/components"

import KeyResultView from "client/pages/okr/keyResult/view"
import KeyResultEdit from "client/pages/okr/keyResult/edit"
import ObjectiveView from "client/pages/okr/objective/view"
import ObjectiveEdit from "client/pages/okr/objective/edit"
import ObjectiveList from "client/pages/okr/objective/list"

const SessionContent = () => (
    <Switch>
        <Route path={`${okrSessionBaseRoute}${okrObjectivesAllRoute}`} component={ObjectiveAll} />
        <Route path={`${okrSessionBaseRoute}${okrObjectivesNestedRoute}`} component={ObjectiveNested} />
        <Route path={`${okrSessionBaseRoute}${okrObjectivesTreeRoute}`} component={ObjectiveTree} />
        <Route path={okrSessionBaseRoute} component={ObjectiveAll} />
    </Switch>
)
export default SessionContent


const ObjectiveAll = () => <Objective objectiveRoute={okrObjectivesAllRoute} />
const ObjectiveNested = () => <Objective objectiveRoute={okrObjectivesNestedRoute} />
const ObjectiveTree = () => <Objective objectiveRoute={okrObjectivesTreeRoute} />


interface ObjectiveProps {
    objectiveRoute: string
}

const Objective = ({
    objectiveRoute,
}: ObjectiveProps) => {
    const modals = useSelector((state: StoreType) => state.system.modals)
    const [modalLength] = useState(modals.length)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setOkrObjectiveRoute(objectiveRoute))
    }, [])

    if (!modalLength) { // render ObjectiveList and open target page with modal
        return (
            <Switch>
                <Route
                    path={`${okrSessionBaseRoute}${objectiveRoute}/${VIEW}/:objectiveId${okrKeyResultsRoute}/:action/:keyResultId`}
                    component={ObjectiveList}
                />
                <Route
                    path={`${okrSessionBaseRoute}${objectiveRoute}/:action/:objectiveId`}
                    component={ObjectiveList}
                />
                <Route
                    path={`${okrSessionBaseRoute}${objectiveRoute}`}
                    component={ObjectiveList}
                />
                <Route
                    path={okrSessionBaseRoute}
                    component={ObjectiveList}
                />
            </Switch>
        )
    }

    return (
        <Switch>
            <Route
                path={`${okrSessionBaseRoute}${objectiveRoute}/${VIEW}/:objectiveId${okrKeyResultsRoute}/${VIEW}/:keyResultId`}
                component={KeyResultView}
            />
            <Route
                path={`${okrSessionBaseRoute}${objectiveRoute}/${VIEW}/:objectiveId${okrKeyResultsRoute}/${EDIT}/:keyResultId`}
                component={KeyResultEdit}
            />
            <Route
                path={`${okrSessionBaseRoute}${objectiveRoute}/${VIEW}/:objectiveId`}
                component={ObjectiveView}
            />
            <Route
                path={`${okrSessionBaseRoute}${objectiveRoute}/${EDIT}/:objectiveId`}
                component={ObjectiveEdit}
            />
        </Switch>
    )
}
